import { useEffect, useState } from 'react';
import { useLocalStorage } from 'react-use';
import { initIndex } from '../Callbacks/algoliaHelper/searchClient';
import contractorPropsController from '../Blocks/FapApp/ResultsPage/contractorPropsController';

function getContractorIds() {
  const windowParams = new URL(document.location).searchParams;
  return windowParams.get('selectedContractors');
}

export default function useSelectedContractors(
  localStorageKey,
  agentServices,
  qualifications,
  savedLocation,
  algoliaIndex,
) {
  const [contractorsTray, setContractorsTray] = useLocalStorage(
    localStorageKey,
    [],
  );
  const [, setContractors] = useState(contractorsTray);
  useEffect(() => {
    const index = initIndex(algoliaIndex);
    const contractorsId = getContractorIds();
    // eslint-disable-next-line no-unused-vars
    let ignore = false;
    if (
      contractorsId &&
      !contractorsTray.length &&
      agentServices &&
      qualifications &&
      savedLocation
    ) {
      index
        .search('', {
          filters: contractorsId
            .split(',')
            .map((f) => `nid=${f}`)
            .join(' OR '),
        })
        .then((res) => {
          const contractors = res.hits.map((hit) => {
            const contractorData = contractorPropsController(
              hit,
              agentServices,
              qualifications,
              savedLocation?.[0]?.geometry?.location,
            );
            return contractorData;
          });

          setContractors(contractors);
          setContractorsTray(contractors);
        });
    }
    return () => {
      ignore = true;
    };
  }, [savedLocation]);

  return { contractorsTray, setContractorsTray };
}
